import React from 'react'
import { Switch } from '@surecompanies/core_components'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { Stack, Typography } from '@sureco/design-system'
import type { UserDto } from 'enrollment-platform/pages/AccessControl/api/access-control.client'
import AdminRoleChips from './AdminRoleChips'

/** One row of GET /customers/:id/admins. `id` is the person id, which is also the Cognito username. */
export interface CustomerAdmin {
  id: string
  firstName?: string
  lastName?: string
  email?: string
  isAdmin: boolean
}

/**
 * Keeps the role chips visibly apart from the Admin User toggle, so the toggle
 * reads as belonging to its own label rather than to the roles.
 */
const ROLES_TO_TOGGLE_GAP = 32

export default function AdminItem({
  admin,
  rbacUser,
  onUpdateAdmin,
  isUpdating,
}: {
  admin: CustomerAdmin
  /** The admin's row from the batch RBAC lookup; absent until it resolves or when the viewer may not read roles. */
  rbacUser?: UserDto
  onUpdateAdmin: (id: string, value: { isAdmin: boolean }) => void
  isUpdating: boolean
}) {
  return (
    <Stack
      direction="row"
      align="center"
      justify="space-between"
      padding={20}
      style={{ border: '1px solid #E0EAF1', borderRadius: 8 }}
    >
      <Stack direction="row" align="center" space={10}>
        <Typography color="#003146" size={16} bold>
          {admin.firstName} {admin.lastName}
        </Typography>
        <Typography color="#00A0A8" size={16}>
          {admin.email}
        </Typography>
      </Stack>
      <Stack direction="row" align="center" space={ROLES_TO_TOGGLE_GAP}>
        <AdminRoleChips user={rbacUser} />
        <Stack direction="row" align="center" space={10}>
          <Switch
            loading={isUpdating}
            disabled={isUpdating}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            value={admin.isAdmin}
            onChange={(checked) =>
              onUpdateAdmin(admin.id, { isAdmin: checked })
            }
          />
          <Typography size={16} color="#003146">
            Admin User
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}
